export const INCOME_MID = [12500, 37500, 70000, 110000];
export const VYDAJE_MID = [10000, 30000, 55000, 85000];
export const SPLATKA_MID = [1500, 5000, 11000, 20000];
export const RATE_MID = {
  hypo: { lt: 4.3, m1: 5.0, m2: 5.8, gt: 7.0, unknown: 5.0 },
  uver: { lt: 6.0, m1: 8.0, m2: 11.0, gt: 15.0, unknown: 8.0 },
};
export const MARKET_RATE = { hypo: 5.0, uver: 8.0 };


export const matrixStrings = {
  tag: { cs: "ZIRSEN · FINANČNÍ ANALÝZA", en: "ZIRSEN · FINANCIAL ANALYSIS" },
  contact: {
    kicker: { cs: "VÝSLEDEK PŘIPRAVEN", en: "RESULT READY" },
    heading: { cs: "Váš výsledek je hotový", en: "Your result is ready" },
    sub: {
      cs: "Hned vám ho ukážeme. Když nám necháte kontakt, pošleme vám ho i e-mailem a ozveme se jen tehdy, kdyby vám analýza mohla ušetřit peníze. Žádný spam, žádný nátlak.",
      en: "We'll show it to you right away. If you leave your contact, we'll email you the result and only reach out if the analysis could actually save you money. No spam, no pressure.",
    },
    emailPh: { cs: "vas@email.cz", en: "you@email.com" },
    phonePh: { cs: "+420 777 123 456", en: "+420 777 123 456" },
    emailLabel: { cs: "E-mail", en: "E-mail" },
    phoneLabel: { cs: "Telefon", en: "Phone" },
    btn: { cs: "Zobrazit výsledek", en: "Show my result" },
    skip: { cs: "Pokračovat bez kontaktu", en: "Continue without contact" },
    note: { cs: "Údaje slouží jen k zaslání výsledku. Bez registrace.", en: "Your details are only used to send the result. No sign-up." },
  },
  back: { cs: "Zpět na web", en: "Back to site" },
  entry: {
    kicker: { cs: "VSTUPNÍ SEKVENCE · PROFIL KLIENTA", en: "ENTRY SEQUENCE · CLIENT PROFILE" },
    title: { cs: "Finanční analýza", en: "Financial Analysis" },
    sub: {
      cs: "Diagnostický nástroj, který za 60 sekund namapuje vaše finance a spočítá index zranitelnosti.",
      en: "A diagnostic instrument that maps your finances and computes your vulnerability index in 60 seconds.",
    },
    trust: [
      { cs: "Šifrováno end-to-end", en: "End-to-end encrypted" },
      { cs: "Nic neukládáme, dokud nepotvrdíte schůzku", en: "Nothing is stored until you book a meeting" },
      { cs: "Bez registrace", en: "No sign-up needed" },
    ],
    aiNote: {
      cs: "Analýzu zpracovává AI a může se mýlit – přesná čísla společně ověříme na schůzce.",
      en: "This analysis is AI-generated and may be inaccurate – we'll verify the exact numbers together in the meeting.",
    },
    nameLabel: { cs: "Jméno klienta", en: "Client name" },
    namePh: { cs: "Jan Novák", en: "John Smith" },
    visionLabel: { cs: "Cílová vize", en: "Target vision" },
    visions: [
      { cs: "Ochránit rodinu a majetek", en: "Protect family & assets" },
      { cs: "Zabezpečit firmu / podnikání", en: "Secure my business" },
      { cs: "Ochránit bydlení a auto", en: "Protect home & car" },
      { cs: "Klid do budoucna", en: "Peace of mind" },
    ],
    typeLabel: { cs: "Profil klienta", en: "Client profile" },
    types: {
      osoba: { cs: "Fyzická osoba", en: "Individual" },
      podnikatel: { cs: "Podnikatel (OSVČ)", en: "Entrepreneur" },
      firma: { cs: "Firma", en: "Company" },
    },
    syncBtn: { cs: "Zahájit synchronizaci", en: "Initialize Sync" },
    syncing: {
      cs: ["Navazuji spojení…", "Kalibruji finanční vektory…", "Profil synchronizován"],
      en: ["Establishing link…", "Calibrating financial vectors…", "Profile synchronized"],
    },
  },
  pillars: {
    pojisteni: { cs: "Pojištění", en: "Insurance" },
    investice: { cs: "Investice", en: "Investments" },
    sporeni: { cs: "Spoření", en: "Savings" },
    hypoteky: { cs: "Hypotéky", en: "Mortgages" },
    uvery: { cs: "Úvěry", en: "Loans" },
  },
  pillarFull: {
    pojisteni: { cs: "Pojištění", en: "Insurance" },
    investice: { cs: "Investice", en: "Investments" },
    sporeni: { cs: "Spoření a penze", en: "Savings & Pension" },
    hypoteky: { cs: "Hypotéky", en: "Mortgages" },
    uvery: { cs: "Úvěry", en: "Consumer Loans" },
  },
  levels: {
    cs: ["Kritické", "Slabé", "Střední", "Dobré", "Výborné"],
    en: ["Critical", "Weak", "Medium", "Good", "Excellent"],
  },
  radar: {
    kicker: { cs: "HOLOGRAFICKÝ RADAR · NEEDS DISCOVERY CORE", en: "HOLOGRAPHIC RADAR · NEEDS DISCOVERY CORE" },
    heading: { cs: "Mapování pěti finančních pilířů", en: "Mapping the five financial pillars" },
    sub: {
      cs: "Odpovězte tlačítky u každé oblasti. Radar se překreslí v reálném čase podle vašich odpovědí.",
      en: "Answer with the buttons in each area. The radar reshapes in real time as you answer.",
    },
    focusPrefix: { cs: "Nejslabší osa", en: "Weakest axis" },
    continueBtn: { cs: "Spustit syntézu", en: "Run Synthesis" },
    continueHint: { cs: "Nejdřív odpovězte ve všech oblastech", en: "Answer all areas first" },
  },
  discovery: {
    pojisteni: {
      label: { cs: "Pojištění", en: "Insurance" },
      hint: { cs: "Co máte aktuálně sjednané? (lze vybrat víc)", en: "What do you currently have? (multi-select)" },
      options: {
        majetek: { cs: "Majetek / bydlení", en: "Property / home" },
        auto: { cs: "Auto", en: "Vehicle" },
        zivot: { cs: "Životní pojištění", en: "Life insurance" },
        firma: { cs: "Firma / podnikání", en: "Business" },
        nic: { cs: "Nemám žádné", en: "None" },
      },
      firmaLocked: { cs: "Dostupné pro podnikatele a firmy", en: "Available for entrepreneurs & companies" },
    },
    investice: {
      label: { cs: "Investice", en: "Investments" },
      mainQ: { cs: "Investujete?", en: "Do you invest?" },
      yes: { cs: "Investuji", en: "I invest" },
      no: { cs: "Neinvestuji", en: "I don't invest" },
      howQ: { cs: "Jak investujete?", en: "How do you invest?" },
      how: {
        pravidelne: { cs: "Pravidelně měsíčně", en: "Regularly, monthly" },
        jednorazove: { cs: "Jednorázově", en: "One-time" },
      },
      lumpQ: { cs: "Kolik jste jednorázově investovali? (Kč)", en: "How much did you invest one-time? (CZK)" },
      lumpPh: { cs: "např. 250 000", en: "e.g. 250,000" },
      whereQ: { cs: "Kam investujete?", en: "Where do you invest?" },
      where: {
        etf: { cs: "ETF / akcie", en: "ETF / stocks" },
        fondy: { cs: "Podílové fondy", en: "Mutual funds" },
        dluhopisy: { cs: "Dluhopisy", en: "Bonds" },
        krypto: { cs: "Krypto", en: "Crypto" },
        reality: { cs: "Reality", en: "Real estate" },
        jine: { cs: "Jiné", en: "Other" },
      },
      amountQ: { cs: "Kolik investujete měsíčně?", en: "How much do you invest monthly?" },
      amounts: {
        cs: ["< 2 000 Kč", "2–5 000 Kč", "5–15 000 Kč", "15 000+ Kč"],
        en: ["< CZK 2,000", "CZK 2–5,000", "CZK 5–15,000", "CZK 15,000+"],
      },
    },
    sporeni: {
      label: { cs: "Spoření", en: "Savings" },
      hint: { cs: "Co využíváte? (lze vybrat víc)", en: "What do you use? (multi-select)" },
      options: {
        zamestnavatel: { cs: "Příspěvek zaměstnavatele", en: "Employer contribution" },
        stat: { cs: "Státní příspěvek (penzijko)", en: "State contribution (pension)" },
        vlastni: { cs: "Vlastní spoření", en: "Own savings" },
        nic: { cs: "Zatím nic", en: "Nothing yet" },
      },
    },
    hypoteky: {
      label: { cs: "Hypotéky", en: "Mortgages" },
      hint: { cs: "Žádné hodnocení – jen fakta z vašeho rozpočtu.", en: "No judgement – just facts from your budget." },
      mainQ: { cs: "Máte hypotéku?", en: "Do you have a mortgage?" },
      yes: { cs: "Ano, splácím", en: "Yes, I'm repaying" },
      no: { cs: "Ne, nemám", en: "No, I don't" },
      rateQ: { cs: "Jaká je vaše aktuální sazba?", en: "What is your current rate?" },
      rates: {
        cs: ["do 4,6 %", "4,6–5,4 %", "5,4–6,2 %", "nad 6,2 %", "Nevím"],
        en: ["up to 4.6 %", "4.6–5.4 %", "5.4–6.2 %", "over 6.2 %", "Not sure"],
      },
      payQ: { cs: "Kolik měsíčně splácíte? (Kč)", en: "Monthly repayment (CZK)" },
      borrowQ: { cs: "Kolik zbývá splatit? (Kč)", en: "Remaining balance (CZK)" },
      yearsQ: { cs: "Za jak dlouho budete mít splaceno? (roky)", en: "Years left to repay" },
    },
    uvery: {
      label: { cs: "Úvěry", en: "Loans" },
      hint: { cs: "Spotřebitelské úvěry, kreditky, kontokorent…", en: "Consumer loans, credit cards, overdrafts…" },
      mainQ: { cs: "Máte nějaké úvěry?", en: "Do you have any loans?" },
      yes: { cs: "Ano, splácím", en: "Yes, I'm repaying" },
      no: { cs: "Ne, nemám", en: "No, I don't" },
      rateQ: { cs: "Jaká je vaše aktuální sazba?", en: "What is your current rate?" },
      rates: {
        cs: ["do 7 %", "7–9 %", "9–13 %", "nad 13 %", "Nevím"],
        en: ["up to 7 %", "7–9 %", "9–13 %", "over 13 %", "Not sure"],
      },
      payQ: { cs: "Kolik měsíčně splácíte? (Kč, všechny úvěry dohromady)", en: "Monthly repayment (CZK, all loans combined)" },
      borrowQ: { cs: "Kolik celkem zbývá splatit? (Kč)", en: "Total remaining balance (CZK)" },
      yearsQ: { cs: "Jak dlouho ještě budete splácet? (roky)", en: "Years left to repay" },
    },
    prijem: {
      label: { cs: "Příjem", en: "Income" },
      hint: { cs: "Jaký je váš čistý měsíční příjem (celé domácnosti)? Jen orientačně.", en: "What is your net monthly (household) income? Roughly is fine." },
      amounts: {
        cs: ["< 25 000 Kč", "25–50 000 Kč", "50–90 000 Kč", "90 000+ Kč"],
        en: ["< CZK 25,000", "CZK 25–50,000", "CZK 50–90,000", "CZK 90,000+"],
      },
    },
    vydaje: {
      label: { cs: "Výdaje", en: "Expenses" },
      hint: { cs: "Jaké jsou vaše celkové měsíční výdaje domácnosti? Včetně splátek a nájmu.", en: "What are your total monthly household expenses? Including repayments and rent." },
      amounts: {
        cs: ["< 20 000 Kč", "20–40 000 Kč", "40–70 000 Kč", "70 000+ Kč"],
        en: ["< CZK 20,000", "CZK 20–40,000", "CZK 40–70,000", "CZK 70,000+"],
      },
    },
    exact: {
      q: { cs: "Nebo napište přesnou částku (Kč):", en: "Or type the exact amount (CZK):" },
      ph: { cs: "např. 62 000", en: "e.g. 62,000" },
      hint: { cs: "Čím konkrétnější číslo zadáte, tím přesnější bude analýza.", en: "The more precise the number, the sharper the analysis." },
    },
    vek: {
      label: { cs: "Věk", en: "Age" },
      hint: { cs: "Věková kategorie — ovlivňuje horizont doporučení (investice, penze).", en: "Age bracket — shapes the recommendation horizon (investments, pension)." },
      amounts: {
        cs: ["do 29 let", "30–44 let", "45–59 let", "60+ let"],
        en: ["under 29", "30–44", "45–59", "60+"],
      },
    },
  },
  analysis: {
    kicker: { cs: "ALGORITMICKÁ SYNTÉZA", en: "ALGORITHMIC SYNTHESIS" },
    heading: { cs: "Syntéza dokončena", en: "Synthesis complete" },
    logs: {
      cs: [
        "Analyzuji vektor rizikové expozice…",
        "Optimalizuji vrstvy pojistného krytí…",
        "Kvantuji pojistné mezery podle os…",
        "Stahuji aktuální tržní sazby (ČBA / BC Index)…",
        "Porovnávám vaše sazby s trhem…",
        "Kompiluji akční matici…",
      ],
      en: [
        "Analyzing risk exposure vector…",
        "Optimizing insurance coverage layers…",
        "Quantifying coverage gaps per axis…",
        "Pulling live market rates (CBA / BC Index)…",
        "Comparing your rates with the market…",
        "Compiling action matrix…",
      ],
    },
    indexLabel: { cs: "Index finanční zranitelnosti", en: "Financial Vulnerability Index" },
    indexHint: { cs: "0 = plně kryté · 100 = kriticky exponované", en: "0 = fully covered · 100 = critically exposed" },
    rateHeading: { cs: "Vaše sazby vs. trh", en: "Your rates vs. the market" },
    rateGood: { cs: "Skvělá sazba – pod trhem", en: "Great rate – below market" },
    rateOk: { cs: "Sazba odpovídá trhu", en: "Rate matches the market" },
    rateBad: { cs: "Sazba nad trhem – refinancování se vyplatí", en: "Above market – refinancing pays off" },
    rateUnknown: { cs: "Sazbu ověříme společně na schůzce", en: "We'll verify the rate in the meeting" },
    marketHypo: { cs: "Trh: cca 4,6–5,4 % (ČBA Hypomonitor 07/2026)", en: "Market: ~4.6–5.4 % (CBA Hypomonitor 07/2026)" },
    marketUver: { cs: "Trh: cca 7–9 % (BC Index 07/2026)", en: "Market: ~7–9 % (BC Index 07/2026)" },
    impactHeading: { cs: "Kolik peněz je ve hře každý měsíc", en: "How much money is at stake each month" },
    impactSub: {
      cs: "U každé oblasti vidíte orientační částku, o kterou měsíčně jde – kolik můžete ušetřit správným nastavením, nebo kolik vás může stát, když to necháte být.",
      en: "For each area you see the approximate monthly amount at stake – what you could save with the right setup, or what it could cost you if left as is.",
    },
    impactPerMonth: { cs: "Kč měsíčně", en: "CZK a month" },
    totalLabel: { cs: "Celkem měsíčně (odhad)", en: "Total per month (estimate)" },
    cashflowLabel: { cs: "Volné prostředky z příjmů (odhad)", en: "Free share of income (estimate)" },
    cashflowBands: {
      deficit: { cs: "Výdaje převyšují příjmy – nutné řešit okamžitě", en: "Expenses exceed income – needs immediate action" },
      tight: { cs: "0–10 % příjmů – rozpočet je napnutý", en: "0–10% of income – budget is tight" },
      ok: { cs: "10–20 % příjmů – prostor na zlepšení", en: "10–20% of income – room to improve" },
      strong: { cs: "20 %+ příjmů – zdravý základ", en: "20%+ of income – healthy base" },
    },
    rangeDisclaimer: {
      cs: "Analýzu zpracovává AI a může se mýlit. Všechna čísla jsou orientační rozpětí na základě vašich odpovědí, ne konkrétní výpočty. Přesná čísla probereme na schůzce.",
      en: "This analysis is AI-generated and may be inaccurate. All figures are indicative ranges based on your answers, not exact calculations. We'll go through precise numbers in the meeting.",
    },
    actionsHeading: { cs: "Prioritní akční matice", en: "Priority Action Matrix" },
    bands: {
      critical: { cs: "Kritická priorita", en: "Critical priority" },
      high: { cs: "Vysoká priorita", en: "High priority" },
      tune: { cs: "Optimalizace", en: "Optimization" },
    },
    toBooking: { cs: "Propojit s poradcem", en: "Connect to an advisor" },
    back: { cs: "Zpět na otázky", en: "Back to questions" },
    verdictTitle: {
      cs: ["Finance pod kontrolou", "Dobrý základ", "Finance potřebují péči", "Vážné mezery", "Kritický stav"],
      en: ["Finances under control", "Solid base", "Finances need care", "Serious gaps", "Critical state"],
    },
    verdictSub: {
      cs: [
        "Skvělá práce — doladíme detaily, ať vám peníze vydělávají víc.",
        "Pár mezer najdeme a spravíme během jedné schůzky.",
        "Několik oblastí je rizikových. Společně je postupně spravíme.",
        "Bez akce riskujete velké výdaje. Schůzku doporučujeme co nejdřív.",
        "Je potřeba jednat hned. Ozvěte se nám.",
      ],
      en: [
        "Great job — we'll fine-tune the details so your money earns more.",
        "We'll find the few gaps and fix them in a single meeting.",
        "Several areas are risky. We'll fix them together, step by step.",
        "Without action you risk major expenses. Book a meeting soon.",
        "Action is needed now. Get in touch with us.",
      ],
    },
    verdictScale: { cs: "Index 0–100 · čím méně, tím líp", en: "Index 0–100 · lower is better" },
    pillarsHeading: { cs: "Co to znamená — jednoduše", en: "What it means — in plain words" },
    targetsHeading: { cs: "Doporučené cíle pro vás", en: "Recommended targets for you" },
    targetReserve: { cs: "Rezerva na horší časy", en: "Rainy-day reserve" },
    targetReserveHint: { cs: "3–6× vašich měsíčních výdajů", en: "3–6× your monthly expenses" },
    targetInvest: { cs: "Pravidelné investování", en: "Regular investing" },
    targetInvestHint: { cs: "10–15 % z příjmů", en: "10–15% of your income" },
    monthly: { cs: "Kč/měs.", en: "CZK/mo." },
    impactNone: { cs: "nic k řešení", en: "nothing to fix" },
    deepCta: { cs: "Chci hlubokou analýzu", en: "I want a deep analysis" },
    deepHint: { cs: "Projděte s AI kompletní hloubkovou analýzu všech financí krok za krokem — zabere cca 30 minut.", en: "Go through a complete in-depth AI analysis of all your finances, step by step — takes about 30 minutes." },
    deepSoon: { cs: "Zatím nedostupné — připravujeme", en: "Not available yet — coming soon" },
    loanMonthly: { cs: "Splátka", en: "Payment" },
    loanBalance: { cs: "Zůstatek", en: "Balance" },
    loanYears: { cs: "zbývá let", en: "years left" },
    loanSavings: { cs: "Při tržní sazbě ušetříte cca", en: "At the market rate you'd save approx." },
    loanMarketPay: { cs: "Tržní splátka by byla", en: "Market payment would be" },
    emailHeading: { cs: "Chcete si výsledek nechat?", en: "Want to keep your result?" },
    emailSub: {
      cs: "Pošleme vám kompletní rozpis analýzy e-mailem – co jste odpověděli, jak jste dopadli i co doporučujeme.",
      en: "We'll email you the full breakdown – your answers, your result and our recommendations.",
    },
    emailNamePh: { cs: "Vaše jméno (nepovinné)", en: "Your name (optional)" },
    emailPh: { cs: "vas@email.cz", en: "you@email.com" },
    emailBtn: { cs: "Poslat výsledek e-mailem", en: "Email me the result" },
    emailSending: { cs: "Odesílám…", en: "Sending…" },
    emailDone: { cs: "Odesláno – zkontrolujte schránku (i spam)", en: "Sent – check your inbox (and spam)" },
    emailErr: { cs: "Odeslání se nepovedlo, zkuste to znovu", en: "Sending failed, please try again" },
  },
  pillarTips: {
    pojisteni: {
      critical: { cs: "Bez klíčových pojistek může jedna nehoda nebo nemoc položit celý rozpočet.", en: "Without key insurance, one accident or illness can break the whole budget." },
      high: { cs: "Základ máte, ale chybí důležitá krytí — typicky životní rizika.", en: "You have the basics, but key coverage is missing — typically life risks." },
      tune: { cs: "Pojištění máte dobře pokryté. Zkontrolujeme jen ceny a aktuálnost.", en: "Your insurance is well covered. We'll just check prices and currency." },
    },
    investice: {
      critical: { cs: "Peníze leží ladem a inflace jim ukrajuje hodnotu.", en: "Your money sits idle and inflation eats its value." },
      high: { cs: "Investujete — doladíme strukturu, poplatky a pravidelnost.", en: "You invest — we'll fine-tune structure, fees and regularity." },
      tune: { cs: "Investice máte nastavené výborně.", en: "Your investments are set up great." },
    },
    sporeni: {
      critical: { cs: "Bez rezervy vás první větší výdaj pošle do minusu.", en: "Without a reserve, the first big expense sends you into the red." },
      high: { cs: "Rezervu máte — ověříme, jestli je dost velká.", en: "You have a reserve — we'll check if it's big enough." },
      tune: { cs: "Rezerva je v pořádku.", en: "Your reserve is in good shape." },
    },
    hypoteky: {
      critical: { cs: "Hypotéka zřejmě žere zbytečně moc — nebo v ní nemáte přehled.", en: "Your mortgage likely costs too much — or you lack an overview." },
      high: { cs: "Hypotéka je v normě, sazbu ověříme vůči dnešnímu trhu.", en: "The mortgage is within range, we'll verify the rate against today's market." },
      tune: { cs: "Hypotéku máte dobře nastavenou.", en: "Your mortgage is set up well." },
      none: { cs: "Bez hypotéky — jedno velké riziko méně.", en: "No mortgage — one big risk less." },
    },
    uvery: {
      critical: { cs: "Spotřebitelské úvěry jsou nejdražší peníze — zbavíme se jich co nejdřív.", en: "Consumer loans are the most expensive money — we'll get rid of them first." },
      high: { cs: "Úvěry držíte na uzdě, sazby ověříme.", en: "Your loans are under control, we'll verify the rates." },
      tune: { cs: "Úvěr máte s dobrou sazbou — jen ověříme podmínky a poplatky.", en: "Your loan has a good rate — we'll just verify the terms and fees." },
      none: { cs: "Bez úvěrů — jedno velké riziko méně.", en: "No loans — one big risk less." },
    },
  },
  impactRanges: {
    critical: { cs: "3 000–8 000", en: "3,000–8,000" },
    high: { cs: "1 500–4 000", en: "1,500–4,000" },
    tune: { cs: "500–1 500", en: "500–1,500" },
  },
  actions: {
    pojisteni: { cs: "Audit vašich pojistných smluv – doplníme chybějící krytí přesně podle vašeho profilu.", en: "Audit of your insurance policies – we'll fill the gaps in coverage exactly for your profile." },
    investice: { cs: "Rozběhnout nebo prověřit investiční plán – ETF, dluhopisy i fondy, diverzifikace podle rizika.", en: "Start or review your investment plan – ETFs, bonds and funds, risk-based diversification." },
    sporeni: { cs: "Nastavit penzijní připojištění s příspěvkem zaměstnavatele a státním příspěvkem.", en: "Set up pension savings with the employer and state contributions." },
    hypoteky: { cs: "Prověřit hypoteční sazbu napříč bankami – trh je 4,6–5,4 %, u starších fixací bývá prostor.", en: "Benchmark your mortgage rate across banks – the market is 4.6–5.4 %, older fixations often have room." },
    uvery: { cs: "Zkonsolidovat drahé úvěry – trh je 7–9 %, cokoliv nad 13 % řešíme okamžitě.", en: "Consolidate expensive loans – the market is 7–9 %, anything above 13 % we fix immediately." },
  },
  actionsNone: {
    hypoteky: { cs: "Bez hypotéky – tady není co řešit.", en: "No mortgage – nothing to fix here." },
    uvery: { cs: "Bez úvěrů – tady není co řešit.", en: "No loans – nothing to fix here." },
  },
  booking: {
    kicker: { cs: "BOOKING BRIDGE", en: "BOOKING BRIDGE" },
    heading: { cs: "Uzamkněte konzultaci", en: "Lock in your consultation" },
    sub: {
      cs: "Výsledky analýzy probereme osobně. Vyberte poradce, termín a formu – kancelář Česká Lípa, u vás, nebo online.",
      en: "We'll walk through your results in person. Pick an advisor, a slot and a format – Česká Lípa office, your place, or online.",
    },
    name: { cs: "Jméno", en: "Name" },
    email: { cs: "E-mail", en: "Email" },
    phone: { cs: "Telefon", en: "Phone" },
    submit: { cs: "Uzamknout termín", en: "Lock the slot" },
    sending: { cs: "Uzamykám…", en: "Locking…" },
    missing: { cs: "Vyberte datum a čas", en: "Pick a date and time" },
    captchaMissing: { cs: "Opište prosím kód z obrázku", en: "Please type the code from the image" },
    captchaWrong: { cs: "Kód z obrázku nesouhlasí — zkuste to znovu.", en: "The code doesn't match — please try again." },
    doneHeading: { cs: "Termín potvrzen", en: "Slot confirmed" },
    doneText: {
      cs: "Termín je uzamčen a výsledky vaší analýzy čekají u poradce. Potvrzení letí na váš e-mail.",
      en: "Your slot is locked and your analysis results are waiting with the advisor. A confirmation is on its way to your inbox.",
    },
    backHome: { cs: "Zpět na hlavní web", en: "Back to main site" },
  },
};
